import React from 'react';

const PopsLabel = ({ text }: { text: string }) => {
  if (!text) {
    return null;
  }

  return <span className='pops-label'>{text}</span>;
};

export default PopsLabel;
